import React from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { SearchEventContainer } from "../../scheduler/component/styled/scheduler";
import ScheduleTable from "../../../../common/scheduleTable";

const SearchSchedule = ({ data, isSearch, searchWord, active }) => {
  const navigate = useNavigate();

  const handleClickEvent = (event) => {
    navigate(`/mypage/detailEvent/${event.scheduleNo}`, {
      state: {
        path: `/mypage/search`,
        search: searchWord,
        tab: active,
      },
    });
  };

  return (
    <SearchEventContainer>
      {isSearch && (
        <div className="searchContaier" style={{ height: "auto" }}>
          {data && data.length > 0 ? (
            <ScheduleTable data={data} onClickEvent={handleClickEvent} />
          ) : (
            <div className="not">일정이 존재하지 않습니다.</div>
          )}
        </div>
      )}
    </SearchEventContainer>
  );
};

export default SearchSchedule;
